module.exports = __webpack_public_path__ + "img/AdobeStock_240773885.0f4c71a5.jpeg";